import api from '@/api';

class AssessmentType {
  /**
   * Index / Get listing of assessment types for a property
   * @returns {*}
   */
  static list(params) {
    return api.get('/assessment/types', {params});
  }
}

export default AssessmentType;
